import { useCallback } from "react";
import { useApiQuery, toList } from "../../useApiQuery";

export interface RealtimeOffer {
    offerId?: string;
    offerName?: string;
    offerNumber?: string;
    offerDescription?: string;
    offerDiscountType?: number;
    offerDiscountValue?: number;
    objApplication?: string;
    startDate?: string;
    endDate?: string;
    sendDate?: string;
    immediateUse?: number;
    triggerOffer?: number;
    globalMinPrice?: number;
    globalMaxPrice?: number;
    globalMinQuantity?: number;
    globalMaxQuantity?: number;
    used?: boolean;
    [key: string]: unknown;
}

const useGetRealtimeAvailableOffers = () => {
    const { data: realtimeOffers, isLoading, error, fetch } = useApiQuery<RealtimeOffer[]>(
        "/getRealtimeAvailableOffersPerson",
        { initialData: [], transform: toList<RealtimeOffer> }
    );

    const getRealtimeOffers = useCallback(
        (identifier: string | number) => fetch({ identifier }),
        [fetch]
    );

    return { realtimeOffers, isLoading, error, getRealtimeOffers };
};

export default useGetRealtimeAvailableOffers;
